module.exports = __webpack_public_path__ + "static/media/female.fcbc5dbf.png";